import React from 'react';
import CommonComponent from '../CommonComponent';
import { appMethod as app } from '@utils/app';

import './TopNav.less';


export class TopNav extends CommonComponent {
  constructor(props) {
    super(props);

    this.state = {
      title: props.title || '',
      isTabBarPage: app.isTabBarPage(),
      currentPageRouter: app.getPageRouter(),
      homePageRouter: app.getHomepageRouter(),
    };
    console.log(this.state)
  }

  stopPropagation = (e) => {
    e.stopPropagation();
  }

  turnBack = () => {
    app.turnBack()
  }

  turnHome = () => {
    app.turnToPage(this.state.homePageRouter, {}, true)
  }


  render(){
    let { title, isTabBarPage } = this.state;
    return (
      <div className="common-component top-nav" >
      <div className="top-nav-content">
        {
          !isTabBarPage && (
            <div className="top-nav-left">
            <label className='ico-moon icon-leftarrow' onClick={this.turnBack}></label>
          </div>
          )
        }
        <div className="top-nav-center">
          <div className="top-nav-title">{title}</div>
        </div>
      </div>
    </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/common/top-nav/TopNav.jsx